'use strict';
/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

/**
 * You can use the import directives.
 */

// Uncomment the import statement below to include the script inside the home function. You can import all other files you need in this script.

import common from './pages/common.js';
import home from './pages/home.js';
import careers from './pages/careers.js';

// --- use home(); -> this is the name of your function in pages/home.js file.

(function($) {

	// Use this variable to set up the common and page specific functions. If you
	// rename this variable, you will also need to rename the namespace below.
	const wh = {
		// All pages
		'common': {
			init: function() {
				// JavaScript to be fired on all pages
				common();
			},
			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired
			}
		},
		// Home page
		'home': {
			init: function() {
				// JavaScript to be fired on the home page
				home();
			},
			finalize: function() {
				// JavaScript to be fired on the home page, after the init JS
			}
		},
		// About us page, note the change from about-us to about_us.
		'about_us': {
			init: function() {
				// JavaScript to be fired on the about us page
			}
		},
		// Career application page (template-career-apply.php).
		// WordPress body class: page-template-template-career-apply → underscored below.
		'page_template_template_career_apply': {
			init: function() {
				careers();
			}
		},
		// Single career post (single-career.twig).
		// WordPress body class: single-career → underscored below.
		'single_career': {
			init: function() {
				careers();
			}
		}
	};

	// The routing fires all common scripts, followed by the page specific scripts.
	// Add additional events for more control over timing e.g. a finalize event
	const UTIL = {
		fire: function(func, funcname, args) {
			const namespace = wh;
			funcname = (funcname === undefined) ? 'init' : funcname;
			const fire = func !== '';
			const fire1 = fire && namespace[func];
			const fire2 = fire1 && typeof namespace[func][funcname] === 'function';

			if (fire2) {
				namespace[func][funcname](args);
			}
		},
		loadEvents: function() {
			// Fire common init JS
			UTIL.fire('common');

			// Fire page-specific init JS, and then finalize JS
			$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
				UTIL.fire(classnm);
				UTIL.fire(classnm, 'finalize');
			});

			// Fire common finalize JS
			UTIL.fire('common', 'finalize');
		}
	};

	// Load Events
	$(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.